export type EngineeringAnswerKind = "structure" | "station" | "pay-item" | "specification" | "calculation" | "general";

const STRUCTURE_RE = /\b(?:str(?:ucture)?\.?\s*(?:no\.?|number|#)?\s*#?\s*\d{1,4}[a-z]?|structure\s+\d{1,4}[a-z]?)\b/i;
const STATION_RE = /\b(?:sta(?:tion)?\.?\s*)?\d{1,5}\+\d{1,2}(?:\.\d+)?\b/i;
const PAY_ITEM_RE = /\b(?:pay[\s-]?item|item\s+(?:no\.?|number|#)?\s*[a-z0-9().-]+|quantity\s+for\s+item)\b/i;
const SPEC_RE = /\b(?:section|spec(?:ification)?s?|special provision|standard specification|subsection)\s*[a-z0-9.-]*/i;
const CALC_RE = /\b(?:calculate|calculation|difference|total|full height|how (?:high|tall|long|much)|slope|percent|percentage|elevation difference|quantity|area|volume)\b/i;

export function classifyEngineeringAnswer(question: string, answerText: string): EngineeringAnswerKind {
  // Entity-specific routes win over generic calculation language. For example,
  // "full height of Structure 55" is primarily a Structure answer even if the
  // final value is computed from two elevations.
  if (STRUCTURE_RE.test(question)) return "structure";
  if (STATION_RE.test(question)) return "station";
  if (PAY_ITEM_RE.test(question)) return "pay-item";
  if (SPEC_RE.test(question)) return "specification";
  if (CALC_RE.test(question) || /\b(?:calculated|equals|=)\b/i.test(answerText)) return "calculation";
  return "general";
}

export const ENGINEERING_ANSWER_LABELS: Record<EngineeringAnswerKind, string> = {
  structure: "Structure intelligence",
  station: "Station intelligence",
  "pay-item": "Pay item intelligence",
  specification: "Specification intelligence",
  calculation: "Verified calculation",
  general: "CEI Nexus Assist",
};

export const ENGINEERING_ANSWER_ICONS: Record<EngineeringAnswerKind, string> = {
  structure: "▦",
  station: "⌖",
  "pay-item": "$",
  specification: "§",
  calculation: "∑",
  general: "N",
};
